import React, { useState, useEffect } from 'react';
import axios from "axios";
// import { useHistory } from "react-router-dom";
import { Grid, Paper, Avatar, TextField, Button, Typography, Link, Box, createMuiTheme, CssBaseline } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import ReceiptIcon from '@material-ui/icons/Receipt';
import AccountCircle from '@material-ui/icons/AccountCircle';
import PhoneIphoneOutlinedIcon from '@material-ui/icons/PhoneIphoneOutlined';
import CoPresentIcon from '@mui/icons-material/CoPresent';
import Captcha from './Captcha';
import useStyles from './styles.js';
import { Scrollbars } from 'react-custom-scrollbars';
import service from './service';
import Alert from '@mui/material/Alert';
import TataSteel from './assets/TataSteel.webp';
import brandLogo from './assets/brandLogoShort.1deeff32.webp';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import LinearProgress from '@mui/material/LinearProgress';
import moment from "moment";
import PDFViewer from 'mgr-pdf-viewer-react';
import xml2js from 'xml2js';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Document,Page } from 'react-pdf/dist/esm/entry.webpack';

var CryptoJS = require("crypto-js");

const key = CryptoJS.enc.Utf8.parse('7251743876083910');
const iv = CryptoJS.enc.Utf8.parse('7251743876083910');
//const url=window.location.href;    
// https://compass1.test.tatasteel.com/onlinetc/
//const url="http://localhost:3001/onlinetc/?INVOICE=TVRJeU5EVXpORE14T1E9PQ==&600"
//const url = "https://compass1.test.tatasteel.com/onlinetc/?INVOICE=VFdwUmVVNXFhM2hOZWtrd1RWRTlQUT09&600"; //demo url for testing


const LandingPage = () => {
    const windowWidth = window.screen.width;
    const classes = useStyles();
    let encryptedInvoiceNo = '';
    let mandt = '';
    const [open, setOpen] = React.useState(false);
    const [numPages, setNumPages] = useState(null);
    const [formValues, setFormValues] = useState({
        invoiceNo: '',
        lastFourDigitInvoice: '',
        name: '',
        mobileNo: '',
        otp: '',
        checkBoxStatus: false,
        captchaStatus: false,
        sendOTPClicked: false,
        showError: false,
        nameShowError: false,
        invoiceShowError: false,
        mobileShowError: false,
        nameerrorMsg: '',
        captchaErrorMsg: '',
        mobileerrorMsg: '',
        invoiceerrorMsg: '',
        showSuccess: false,
        data_sendOtp: {},
        errorMsg: '',
        progress: false,
        pdf: '',
        show_pdf: false,
        correctOtp: '',
        submit_disable: true,
        sendOtp_disable: true,
        captchaError: false,
        invoiceError: false,
        invoiceErrorMsg: '',
        cxConsentData: '',
        verifyConsent: '',
        consent: false,
        consentError: false,
        consentErrorMsg: '',
        consentVerification:'',
        E_INV_NO:''
    })
    useEffect(() => {
        if (window.location.href != 'https://compass.tatasteel.com/onlinetc/') {    //for production https://compass.tatasteel.com/onlinetc/
            const url = window.location.href;
            encryptedInvoiceNo = url.substring(url.indexOf("=") + 1, url.lastIndexOf('&'));
            mandt = url.substring(url.lastIndexOf('&') + 1, url.length);
            localStorage.setItem('Invoice', encryptedInvoiceNo);
            localStorage.setItem('mandt', mandt);
            window.location.href = 'https://compass.tatasteel.com/onlinetc/';      // for production https://compass.tatasteel.com/onlinetc/
        }

    }, [])
    const paperStyle = { padding: '5%', height: '100vh'}
    const avatarStyle = { backgroundColor: '#1bbd7e', height: '30px', width: '30px' }
    const avatarStyleIcon = { backgroundColor: '#1bbd7e', height: "60px", width: "60px" }
    const btnstyle = { margin: '5px 0' }
    const fieldStyle = { marginTop: '3%' }
    const validationCheck = (status) => {
        if ((formValues.lastFourDigitInvoice === '' || formValues.mobileNo === '' || formValues.name === '' || localStorage.getItem('Invoice') == null) && status !== '') {
            if (formValues.lastFourDigitInvoice === '' && formValues.mobileNo === '' && formValues.name === '' && localStorage.getItem('Invoice') == null) {
                setFormValues({
                    ...formValues,
                    'invoiceShowError': true,
                    'mobileShowError': true,
                    'nameShowError': true,
                    'captchaStatus': status, 'captchaError': false,
                    'mobileerrorMsg': 'Please enter valid 10 digit mobile no.',
                    'invoiceerrorMsg': 'Please enter last 4 digits of invoice no.',
                    'invoiceError': true,
                    'invoiceErrorMsg': 'Invoice no is blank, Kindly Re-Scan the QR code',
                    'nameerrorMsg': 'Please enter valid user name without special character($,&,%...) & numbers'
                })
            }
            else if (formValues.lastFourDigitInvoice === '' && formValues.mobileNo === '') {
                setFormValues({
                    ...formValues,
                    'invoiceShowError': true,
                    'mobileShowError': true,
                    'captchaStatus': status, 'captchaError': false,
                    'mobileerrorMsg': 'Please enter valid 10 digit mobile no.',
                    'invoiceerrorMsg': 'Please enter last 4 digits of invoice no.',
                })
            }
            else if (formValues.mobileNo === '' && formValues.name === '') {
                setFormValues({
                    ...formValues,
                    'mobileShowError': true,
                    'nameShowError': true,
                    'captchaStatus': status, 'captchaError': false,
                    'mobileerrorMsg': 'Please enter valid 10 digit mobile no.',
                    'nameerrorMsg': 'Please enter valid user name without special character($,&,%...) & numbers'
                })
            }
            else if (formValues.lastFourDigitInvoice === '' && formValues.name === '') {
                setFormValues({
                    ...formValues,
                    'invoiceShowError': true,
                    'nameShowError': true,
                    'captchaStatus': status, 'captchaError': false,
                    'invoiceerrorMsg': 'Please enter last 4 digits of invoice no.',
                    'nameerrorMsg': 'Please enter valid user name without special character($,&,%...) & numbers'
                })
            }
            else if (localStorage.getItem('Invoice') == null) {
                setFormValues({
                    ...formValues,
                    'invoiceError': true,
                    'invoiceErrorMsg': 'Invoice no is blank, Kindly Re-Scan the QR code'
                })
            }
            else if (formValues.mobileNo === '') {
                setFormValues({
                    ...formValues,
                    'mobileShowError': true,
                    'captchaStatus': status, 'captchaError': false,
                    'mobileerrorMsg': 'Please enter valid 10 digit mobile no.'
                })
            }
            else if (formValues.name === '') {
                setFormValues({
                    ...formValues,
                    'nameShowError': true,
                    'captchaStatus': status, 'captchaError': false,
                    'nameerrorMsg': 'Please enter valid user name without special character($,&,%...) & numbers'
                })
            }
            else if (formValues.lastFourDigitInvoice === '') {
                setFormValues({
                    ...formValues,
                    'invoiceShowError': true,
                    'captchaStatus': status, 'captchaError': false,
                    'invoiceerrorMsg': 'Please enter last 4 digits of invoice no.'
                })
            }
         
        } else {
            if (formValues.consentVerification == '' &&  (formValues.mobileNo !== '' && formValues.name !== '')) {
                verifyConsent();
            }
            setFormValues({ ...formValues, 'captchaStatus': status, 'captchaError': false });
           
        }
        
    };

    var jwt = require('jsonwebtoken');

    function GetProcedureJWT() { // send otp
        let privateKey = "c8caa6bb-3bff-44ad-9265-c55f3b847bdd"   //prd:-c8caa6bb-3bff-44ad-9265-c55f3b847bdd     uat:-e6dac1d8-70b6-48b9-afd0-f658ff884681
        let token = jwt.sign({
            apikey: "S9uG9vTWfuZ4BmZij2d2sAtkzXu50DmO", //prd:-S9uG9vTWfuZ4BmZij2d2sAtkzXu50DmO   uat:-OnbGnfor3QgbGiRoAze2eWqguGzRybvl
            appName: "OnlineTC",
            iat: Math.floor(Date.now() / 1000) - 30
        }, privateKey,
            {
                algorithm: 'HS256', notBefore: 0, expiresIn: 300,
                audience: 'TSL-APIGEE-GenerateJWT-OnlineTC', issuer: 'OnlineTCProgram',
            },
        );
        return token;
    }

    function GetJWT() {     //validate TC
        let privateKey = "27b1b673-fa17-407c-a330-28f7d39e24a6"  //prd:-27b1b673-fa17-407c-a330-28f7d39e24a6  uat:-f60c0df4-c8b5-41e0-a5e5-3b43386f44a8
        let token = jwt.sign({
            apikey: "S9uG9vTWfuZ4BmZij2d2sAtkzXu50DmO",   //prd:-S9uG9vTWfuZ4BmZij2d2sAtkzXu50DmO  uat:-OnbGnfor3QgbGiRoAze2eWqguGzRybvl
            appName: "OnlineTC",
            iat: Math.floor(Date.now() / 1000) - 30
        }, privateKey,
            {
                algorithm: 'HS256', notBefore: 0, expiresIn: 300,
                audience: 'TSL-APIGEE-GenerateJWT-OnlineTCAPI', issuer: 'OnlineTCProgram',
            },
        );
        return token;
    }
    const setPdf = (pdf,E_INV_NO) => {
        setFormValues({ ...formValues, 'show_pdf': true, 'pdf': pdf ,'E_INV_NO':E_INV_NO})
    }
    const handleSendOTP = (action) => {

        setFormValues({ ...formValues, 'progress': true, 'otp': '' })
        let payload = {
            "route": "smsproxy/SendOtp",
            "requestBody": {
                "mobNo": formValues.mobileNo,
                "imeiNo": "",
                "strMSG": ""
            }
        };

        var ciphertext = CryptoJS.AES.encrypt(JSON.stringify({
            "LN_TRANS_NO": action === 'SENDOTP' ? '' : formValues.data_sendOtp.LN_TRANS_NO,
            "LS_ACTION_TAG": action,
            "LS_INVOICE_NO": localStorage.getItem('Invoice'),
            "LS_INVOICE_TYPE": "ORIGINAL",
            "LS_COMP_CD": "",
            "LS_PLANT_CD": "",
            "LS_TC_UNIQUE_NO": "",
            "LS_MANDT": localStorage.getItem('mandt'),
            "LS_USER_NAME": formValues.name,
            "LS_MOBILE_NO": CryptoJS.AES.encrypt(JSON.stringify(formValues.mobileNo), key, {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            }).toString(),
            "LS_USER_COMP_NAME": "",
            "LS_USER_ADDITIONAL_INFO": "",
            "LN_OTP_CRT_NO": "",
            "LD_OTP_CRT_DT": "",
            "LD_OTP_VALID_TILL_DT": "",
            "LN_OTP_VALID_DURATION": "",
            "LD_OTP_SEND_FL_OUT": "",
            "LD_OTP_VALIDATED_STATUS_OUT": "",
            "LD_OTP_SEND_COUNTER_OUT": "",
            "LS_API_RESPONSE_FL": "",
            "LS_API_TRIGG_TIMESTAMP": "",
            "LS_API_RESPONSE_TIMESTAMP": "",
            "LS_API_MESSAGE": "",
            "LS_ERROR_CD": "",
            "LS_ERROR_MESSAGE": ""
        }), key, {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            }).toString();
        let authPayload = {
            "route": "onlinetcapi/ValidateTC/ValidateTC",
            "requestBody": {
                "EncodedString": ciphertext
            }
        };
        let token = GetJWT();//false token
        service.getValidateTcJWTToken(token).then(
            (response4) => {
                let validateTcToken = response4.headers['jwt-response'];
                service.getAuthentication(authPayload, validateTcToken).then(
                    (response1) => {
                        if (response1.data.LS_ERROR_CD == 0) {

                            let token_otpProcedure = GetProcedureJWT();
                            service.getOtpJWTToken(token_otpProcedure).then(
                                (response2) => {
                                    let otpToken = response2.headers['jwt-response'];
                                    service.sendOtp(payload, otpToken).then((response3) => {

                                        var ciphertext2 = CryptoJS.AES.encrypt(JSON.stringify({
                                            "LN_TRANS_NO": response1.data.LN_TRANS_NO,
                                            "LS_ACTION_TAG": 'SAVEOTP',
                                            "LS_INVOICE_NO": localStorage.getItem('Invoice'),
                                            "LS_INVOICE_TYPE": "ORIGINAL",
                                            "LS_COMP_CD": "",
                                            "LS_PLANT_CD": "",
                                            "LS_TC_UNIQUE_NO": "",
                                            "LS_MANDT": localStorage.getItem('mandt'),
                                            "LS_USER_NAME": formValues.name,
                                            "LS_MOBILE_NO": CryptoJS.AES.encrypt(JSON.stringify(formValues.mobileNo), key, {
                                                keySize: 128 / 8,
                                                iv: iv,
                                                mode: CryptoJS.mode.CBC,
                                                padding: CryptoJS.pad.Pkcs7
                                            }).toString(),
                                            "LS_USER_COMP_NAME": "",
                                            "LS_USER_ADDITIONAL_INFO": "",
                                            "LN_OTP_CRT_NO": parseInt(response3.data),
                                            "LD_OTP_CRT_DT": "",
                                            "LD_OTP_VALID_TILL_DT": "",
                                            "LN_OTP_VALID_DURATION": "",
                                            "LD_OTP_SEND_FL_OUT": "",
                                            "LD_OTP_VALIDATED_STATUS_OUT": response3.statusText[0],
                                            "LD_OTP_SEND_COUNTER_OUT": "",
                                            "LS_API_RESPONSE_FL": "",
                                            "LS_API_TRIGG_TIMESTAMP": "",
                                            "LS_API_RESPONSE_TIMESTAMP": "",
                                            "LS_API_MESSAGE": "",
                                            "LS_ERROR_CD": "",
                                            "LS_ERROR_MESSAGE": ""
                                        }), key, {
                                                keySize: 128 / 8,
                                                iv: iv,
                                                mode: CryptoJS.mode.CBC,
                                                padding: CryptoJS.pad.Pkcs7
                                            }).toString();

                                        let secondAuthPayload = {
                                            "route": "onlinetcapi/ValidateTC/ValidateTC",
                                            "requestBody": {
                                                "EncodedString": ciphertext2
                                            }
                                        };
                                        let token_saveOtp = GetJWT();
                                        service.getValidateTcJWTToken(token_saveOtp).then((response) => {
                                            let secondValidateTcToken = response.headers['jwt-response'];
                                            service.getAuthentication(secondAuthPayload, secondValidateTcToken).then((response) => {
                                                if (response.data.LS_ERROR_CD == 0) {
                                                    setFormValues({ ...formValues, 'sendOTPClicked': true, 'correctOtp': response3.data, 'data_sendOtp': response.data, 'showError': false });
                                                }
                                                else {
                                                    setFormValues({
                                                        ...formValues,
                                                        'showError': true,
                                                        'correctOtp': response3.data,
                                                        'errorMsg': response.data.LS_ERROR_MESSAGE,
                                                        'progress': false
                                                    })
                                                }

                                            }).catch((error) => {
                                                setFormValues({
                                                    ...formValues,
                                                    'showError': true,
                                                    'correctOtp': response3.data,
                                                    'errorMsg': 'Something went wrong while Validate TC saveOtp' + error,
                                                    'progress': false
                                                })
                                            })
                                        }).catch((error) => {
                                            setFormValues({
                                                ...formValues,
                                                'showError': true,
                                                'correctOtp': response3.data,
                                                'errorMsg': 'Something went wrong while generating token for Validate TC saveOtp' + error,
                                                'progress': false
                                            })
                                        })

                                    }).catch((error) => {
                                        setFormValues({
                                            ...formValues,
                                            'showError': true,
                                            'errorMsg': 'Something went wrong while sending OTP' + error,
                                            'progress': false
                                        })
                                    })
                                }
                            ).catch((error) => {
                                setFormValues({
                                    ...formValues,
                                    'showError': true,
                                    'errorMsg': 'Something went wrong while generating token for send OTP' + error,
                                    'progress': false
                                })
                            })
                        }
                        else {
                            setFormValues({
                                ...formValues,
                                'showError': true,
                                'errorMsg': response1.data.LS_ERROR_MESSAGE,
                                'progress': false
                            })
                        }
                    }
                ).catch((error) => {
                    setFormValues({
                        ...formValues,
                        'showError': true,
                        'errorMsg': 'Something went wrong while Validate TC call' + error,
                        'progress': false
                    })
                });
            }).catch((error) => {
                setFormValues({
                    ...formValues,
                    'showError': true,
                    'errorMsg': 'Something went wrong while generating token for Validate TC call' + error,
                    'progress': false
                })
            });
    }
    const handleSubmit = () => {
        setFormValues({ ...formValues, 'progress': true, 'submit_disable': true })
        var ciphertext3 = CryptoJS.AES.encrypt(JSON.stringify({
            "LN_TRANS_NO": formValues.data_sendOtp.LN_TRANS_NO,
            "LS_ACTION_TAG": "VALIDATEOTP",
            "LS_INVOICE_NO": formValues.data_sendOtp.LS_INVOICE_NO,
            "LS_INVOICE_TYPE": "ORIGINAL",
            "LS_COMP_CD": "",
            "LS_PLANT_CD": "",
            "LS_TC_UNIQUE_NO": "",
            "LS_MANDT": localStorage.getItem('mandt'),
            "LS_USER_NAME": formValues.name,
            "LS_MOBILE_NO": CryptoJS.AES.encrypt(JSON.stringify(formValues.mobileNo), key, {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            }).toString(),
            "LS_USER_COMP_NAME": "",
            "LS_USER_ADDITIONAL_INFO": "",
            "LN_OTP_CRT_NO": parseInt(formValues.otp),
            "LD_OTP_CRT_DT": "",
            "LD_OTP_VALID_TILL_DT": "",
            "LN_OTP_VALID_DURATION": "",
            "LD_OTP_SEND_FL_OUT": "",
            "LD_OTP_VALIDATED_STATUS_OUT": "",
            "LD_OTP_SEND_COUNTER_OUT": "",
            "LS_API_RESPONSE_FL": "",
            "LS_API_TRIGG_TIMESTAMP": "",
            "LS_API_RESPONSE_TIMESTAMP": "",
            "LS_API_MESSAGE": "",
            "LS_ERROR_CD": "",
            "LS_ERROR_MESSAGE": ""
        }), key, {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            }).toString();
        let payload = {
            "route": "onlinetcapi/ValidateTC/ValidateTC",
            "requestBody": {
                "EncodedString": ciphertext3
            }
        };

        const pdfPayload = {
            "route": "onlinetcapi/PrintTC/PrintTC",
            "requestBody": {
                strMandt: localStorage.getItem('mandt'),
                strPartInvNo: formValues.lastFourDigitInvoice,
                strEncryptedInvNo: localStorage.getItem('Invoice')
            }
        };
        let token = GetJWT();
        service.getValidateTcJWTToken(token).then(
            (response) => {
                let validateTcToken = response.headers['jwt-response'];
                service.getAuthentication(payload, validateTcToken).then(
                    (response1) => {
                        if (response1.data.LS_ERROR_CD == 0) {
                            if (formValues.correctOtp == formValues.otp) {
                                let token_pdf = GetJWT();
                                service.getValidateTcJWTToken(token_pdf).then(
                                    (response_pdf) => {
                                        let pdfToken = response_pdf.headers['jwt-response'];
                                        service.getAuthentication(pdfPayload, pdfToken).then((pdf_response) => {
                                            let token_apitc = GetJWT();
                                            service.getValidateTcJWTToken(token_apitc).then(
                                                (response2) => {
                                                    let apitc_validateTcToken = response2.headers['jwt-response'];
                                                    var ciphertext4 = CryptoJS.AES.encrypt(JSON.stringify({
                                                        "LN_TRANS_NO": formValues.data_sendOtp.LN_TRANS_NO,
                                                        "LS_ACTION_TAG": 'APITC',
                                                        "LS_INVOICE_NO": pdf_response.data.E_INV_NO == null || pdf_response.data.E_INV_NO == "" ? localStorage.getItem('Invoice') : pdf_response.data.E_INV_NO,
                                                        "LS_INVOICE_TYPE": "ORIGINAL",
                                                        "LS_COMP_CD": "",
                                                        "LS_PLANT_CD": pdf_response.data.E_PLANT || '',
                                                        "LS_TC_UNIQUE_NO": pdf_response.data.E_TC_NO || '',
                                                        "LS_MANDT": pdf_response.data.E_MANDT == null || pdf_response.data.E_MANDT == "" ? localStorage.getItem('mandt') : pdf_response.data.E_MANDT,
                                                        "LS_USER_NAME": formValues.name,
                                                        "LS_MOBILE_NO": CryptoJS.AES.encrypt(JSON.stringify(formValues.mobileNo), key, {
                                                            keySize: 128 / 8,
                                                            iv: iv,
                                                            mode: CryptoJS.mode.CBC,
                                                            padding: CryptoJS.pad.Pkcs7
                                                        }).toString(),
                                                        "LS_USER_COMP_NAME": "",
                                                        "LS_USER_ADDITIONAL_INFO": "",
                                                        "LN_OTP_CRT_NO": "",
                                                        "LD_OTP_CRT_DT": "",
                                                        "LD_OTP_VALID_TILL_DT": "",
                                                        "LN_OTP_VALID_DURATION": "",
                                                        "LD_OTP_SEND_FL_OUT": "",
                                                        "LD_OTP_VALIDATED_STATUS_OUT": "",
                                                        "LD_OTP_SEND_COUNTER_OUT": "",
                                                        "LS_API_RESPONSE_FL": pdf_response.data.E_MSG_TEXT == "Success" ? 'Y' : 'E',
                                                        "LS_API_TRIGG_TIMESTAMP": '',
                                                        "LS_API_RESPONSE_TIMESTAMP": '',
                                                        "LS_API_MESSAGE": pdf_response.data.E_MSG_TEXT,
                                                        "LS_ERROR_CD": "",
                                                        "LS_ERROR_MESSAGE": ""
                                                    }), key, {
                                                            keySize: 128 / 8,
                                                            iv: iv,
                                                            mode: CryptoJS.mode.CBC,
                                                            padding: CryptoJS.pad.Pkcs7
                                                        }).toString();
                                                    let apitcPayload = {
                                                        "route": "onlinetcapi/ValidateTC/ValidateTC",
                                                        "requestBody": {
                                                            "EncodedString": ciphertext4
                                                        }
                                                    };
                                                    service.getAuthentication(apitcPayload, apitc_validateTcToken).then(
                                                        (response3) => {
                                                            if (response3.data.LS_ERROR_CD == 0) {
                                                                if (pdf_response.data.E_MSG_TEXT == "Success") {
                                                                    setFormValues({
                                                                        ...formValues,
                                                                        'showSuccess': true,
                                                                        'progress': false,
                                                                        'showError': false,
                                                                        'submit_disable': true,
                                                                        'E_INV_NO':pdf_response.data.E_INV_NO
                                                                    });

                                                                    setPdf(pdf_response.data.E_PDF,pdf_response.data.E_INV_NO);
                                                                    localStorage.clear();
                                                                } else {
                                                                    localStorage.clear();
                                                                    setFormValues({
                                                                        ...formValues,
                                                                        'showSuccess': false,
                                                                        'progress': false,
                                                                        'showError': true,
                                                                        'submit_disable': true,
                                                                        'errorMsg': response3.data.LS_API_MESSAGE + ". Kindly Re-Scan the QR Code."
                                                                    });
                                                                }
                                                            }
                                                            else {
                                                                setFormValues({
                                                                    ...formValues,
                                                                    'showError': true,
                                                                    'errorMsg': response3.data.LS_ERROR_MESSAGE,
                                                                    'progress': false,
                                                                    'submit_disable': false
                                                                })
                                                            }
                                                        }).catch((error) => {
                                                            setFormValues({
                                                                ...formValues,
                                                                'showError': true,
                                                                'errorMsg': 'Something went wrong while APITC call' + error,
                                                                'progress': false,
                                                                'submit_disable': false
                                                            })
                                                        })
                                                }).catch((error) => {
                                                    setFormValues({
                                                        ...formValues,
                                                        'showError': true,
                                                        'errorMsg': 'Something went wrong while APITC validation' + error,
                                                        'progress': false,
                                                        'submit_disable': false
                                                    })
                                                })
                                        }).catch((error) => {
                                            setFormValues({
                                                ...formValues,
                                                'showError': true,
                                                'errorMsg': 'Something went wrong while pdf download ' + error,
                                                'progress': false,
                                                'submit_disable': false
                                            })
                                        })
                                    })
                            } else {
                                setFormValues({
                                    ...formValues,
                                    'showError': true,
                                    'errorMsg': 'Otp mismatched',
                                    'progress': false,
                                    'submit_disable': false
                                })
                            }
                        }
                        else {
                            setFormValues({
                                ...formValues,
                                'showError': true,
                                'errorMsg': response1.data.LS_ERROR_MESSAGE,
                                'progress': false
                            })
                        }
                    }).catch((error) => {
                        setFormValues({
                            ...formValues,
                            'showError': true,
                            'errorMsg': 'Something went wrong while OTP validation ' + error,
                            'progress': false
                        })
                    })
            });

    };
    const formLabelsTheme = createMuiTheme({
        overrides: {
            MuiFormLabel: {
                asterisk: {
                    color: '#db3131',
                    '&$error': {
                        color: '#db3131'
                    },
                }
            }
        }
    });
    const handleOtpChange = (e) => {
        setFormValues({ ...formValues, 'otp': e.target.value, 'submit_disable': false })
    };

    const callSoapApi = () => {
        setFormValues({ ...formValues, 'progress': true })
        let cipherpayload = CryptoJS.AES.encrypt(JSON.stringify({
            'systemid': "S0061", //production appcode:-  7f96270beda04144a2014d4f4f2c1c82 uat:-4bf42996b5334788a47199a4372f0410
            'appcode': "7f96270beda04144a2014d4f4f2c1c82"
        }), key, {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            }).toString();
        let payload = {
            "route": "onlinetcapi/PIIConsent/PIIConsent",
            "requestBody": {
                "EncodedString": cipherpayload //production appcode:-  7f96270beda04144a2014d4f4f2c1c82 uat :-4bf42996b5334788a47199a4372f0410
            }
        };

        let token = GetJWT();
        service.getValidateTcJWTToken(token).then(
            (response) => {
                let validateTcToken = response.headers['jwt-response'];
                service.getAuthentication(payload, validateTcToken).then(
                    (data) => {
                        setFormValues({ ...formValues, 'progress': false, 'consentError': false, 'checkBoxStatus': !formValues.checkBoxStatus, 'cxConsentData': data.data });
                        setOpen(true);
                    }).catch((error) => {
                        setFormValues({ ...formValues, 'progress': false, 'consentError': true, 'consentErrorMsg': 'Error in PIIConsent Api' })
                    })
            });
    };
    const consentVerification = () => {
        if (formValues.consentVerification === 'N') {
            callSoapApi();
        }
        else if (formValues.consentVerification === 'Y') {
            setFormValues({ ...formValues, 'consent': true, 'consentError': false, 'checkBoxStatus': !formValues.checkBoxStatus })
        }
    };

    const verifyConsent = () => {
        let userid = (formValues.name + formValues.mobileNo).replace(" ", "");
      
        //prod url  http://corporateintranet.corp.tatasteel.com/PIICONSENT/PIICONSENT.asmx?wsdl
        let cipherpayload = CryptoJS.AES.encrypt(JSON.stringify({
            'systemid': "S0061",
            'userid': userid, //production appcode:-  7f96270beda04144a2014d4f4f2c1c82
            'appcode': "7f96270beda04144a2014d4f4f2c1c82"
        }), key, {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            }).toString();

        let payload = {
            "route": "onlinetcapi/PIIConsent/PIIverifyconsent",
            "requestBody": {
                "EncodedString": cipherpayload
            }
        };

        let token = GetJWT();//false token
        service.getValidateTcJWTToken(token).then(
            (response) => {
                let validateTcToken = response.headers['jwt-response'];
                service.getAuthentication(payload, validateTcToken).then(
                    (data) => {
                        
                        setFormValues({...formValues,'consentVerification':data.data})
                        // if (data.data === 'N') {
                        //     callSoapApi();
                        // }
                        // else if (data.data === 'Y') {
                        //     setFormValues({ ...formValues, 'consent': true, 'consentError': false, 'checkBoxStatus': !formValues.checkBoxStatus })
                        // }
                    }).catch((error) => {
                        setFormValues({ ...formValues, 'consentError': true, 'consentErrorMsg': 'Error in PIIverifyconsent Api' })
                    })
            });
    };

    const updateConsent = () => {
        var messageid = "";
        let userid = (formValues.name + formValues.mobileNo).replace(" ", "");
        if (document.getElementsByName('type')[0].checked) {
            messageid = document.getElementsByName('type')[0].value;
        }
        else if (document.getElementsByName('type')[1].checked) {
            messageid = document.getElementsByName('type')[1].value;
        }
        else if (document.getElementsByName('type')[2].checked) {
            messageid = document.getElementsByName('type')[2].value;
        }
        else if (document.getElementsByName('type')[3].checked) {
            messageid = document.getElementsByName('type')[3].value;
        }
        else if (document.getElementsByName('type')[4].checked) {
            messageid = document.getElementsByName('type')[4].value;
        }

        let cipherpayload = CryptoJS.AES.encrypt(JSON.stringify({
            'systemid': "S0061",
            'userid': userid,
            'status': 'A',
            'phone': formValues.mobileNo,
            'country': 'India',
            'messageid': messageid, //production appcode:-  7f96270beda04144a2014d4f4f2c1c82
            'appcode': "7f96270beda04144a2014d4f4f2c1c82"
        }), key, {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            }).toString();

        let payload = {
            "route": "onlinetcapi/PIIConsent/PIIupdateconsent",
            "requestBody": {
                "EncodedString": cipherpayload
            }
        };

        let token = GetJWT();//false token
        service.getValidateTcJWTToken(token).then(
            (response) => {
                let validateTcToken = response.headers['jwt-response'];
                service.getAuthentication(payload, validateTcToken).then(
                    (data) => {
                        if (data.data === "Selected Choice Logged Successfully") {
                            setFormValues({ ...formValues, 'consent': true, 'consentError': false })
                        }
                    }).catch((error) => {
                        setFormValues({ ...formValues, 'progress': false, 'consentError': true, 'consentErrorMsg': 'Error in PIIupdateconsent Api' })
                    })
            });
    };



    //prod url  http://corporateintranet.corp.tatasteel.com/PIICONSENT/PIICONSENT.asmx?wsdl
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setFormValues({
            ...formValues,
            'checkBoxStatus': !formValues.checkBoxStatus
        })
        setOpen(false);
    };


    const onCheckBoxClicked = (e) => {
        //original
        if (!formValues.checkBoxStatus && !formValues.consent) {
            consentVerification();
        } else {
            setFormValues({ ...formValues, 'checkBoxStatus': !formValues.checkBoxStatus })
        }
        //end
    };
    const handleOnAgree = () => {

        updateConsent();
        setOpen(false);

    };

    return (
        <div >
            {!formValues.show_pdf ? <Grid container className={classes.root} >
                <MuiThemeProvider theme={formLabelsTheme}>
                    <CssBaseline />
                    <Grid md={12} container >
                        <Grid md={12} item>
                            <Dialog
                                open={open}
                                onClose={handleClose}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogContent>

                                    <div dangerouslySetInnerHTML={{ __html: formValues.cxConsentData }}></div>

                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={handleOnAgree} type='button' color='primary' variant="contained" autoFocus>
                                        I Agree
                                    </Button>
                                    <Button type='button' color='error' variant="contained" onClick={handleClose}>I Disagree</Button>
                                </DialogActions>
                            </Dialog>
                        </Grid>
                        <Grid item xs={false} sm={false} md={7} className={classes.image}></Grid>
                        <Grid item xs={12} sm={8} md={5}>
                            <form >
                                <Paper elevation={3} style={paperStyle}>

                                    <Scrollbars autoHide >
                                        <Grid md={12} container >
                                            <Grid xs={3} md={windowWidth == 320 ? 1 : 2} item>
                                                <img style={{ height: windowWidth == 320 ? '80%' : '60%', width: windowWidth == 320 ? '200%' : '120%', marginTop: '5%', marginBottom: 0 }} src={TataSteel} /></Grid>
                                            <Grid item xs={7} align='center' md={8}>
                                                <Avatar style={avatarStyleIcon}><CoPresentIcon sx={{ height: '40px', width: '40px' }} /></Avatar>
                                            </Grid>
                                            <Grid item xs={2} md={2}><img style={{ marginTop: '5%', height: windowWidth == 320 ? '80%' : '60%', width: windowWidth == 320 ? '80%' : '50%', marginBottom: 0 }} src={brandLogo} /></Grid></Grid>

                                        <Grid align='center' md={12}>
                                            {/* <Avatar style={avatarStyleIcon}><CoPresentIcon sx={{ height: '40px', width: '40px' }} /></Avatar> */}
                                            <h2 style={{ marginBottom: 20, marginTop: 10 }}>Welcome to Online TC Verification System</h2>
                                        </Grid>
                                        <Grid sx={fieldStyle} container md={12} >
                                            <Grid md={6} sx={{ p: "1px", pr: 1 }}>
                                                <Box sx={{ marginRight: 5, marginBottom: 10, minWidth: 240 }}>
                                                    <TextField
                                                        label='Invoice No. of Tata Steel'
                                                        size='medium'
                                                        required
                                                        fullWidth
                                                        disabled
                                                        defaultValue={localStorage.getItem('Invoice') == null ? '' : '************'}
                                                        variant="filled"
                                                        type='string'
                                                    /></Box>
                                            </Grid>
                                            <Grid md={6} sx={{ p: "1px", pr: 1 }}>
                                                <Box sx={{ marginBottom: 10 }}>
                                                    <TextField label='Invoice Last 4 digit '
                                                        placeholder='Last four digit of Invoice'
                                                        type='number'
                                                        fullWidth
                                                        autoFocus
                                                        onChange={(e) => {
                                                            if (e.target.value.length < 4) {
                                                                setFormValues({
                                                                    ...formValues,
                                                                    'lastFourDigitInvoice': e.target.value,
                                                                    'invoiceShowError': true,
                                                                    'invoiceerrorMsg': 'Please enter last 4 digits of Invoice No.'
                                                                })
                                                            } else {
                                                                setFormValues({ ...formValues, 'invoiceShowError': false, 'lastFourDigitInvoice': e.target.value })
                                                            }
                                                        }
                                                        }
                                                        variant={formValues.checkBoxStatus ? "filled" : "outlined"}
                                                        value={formValues.lastFourDigitInvoice}
                                                        color="success"
                                                        focused
                                                        required
                                                        onInput={(e) => {
                                                            e.target.value = (e.target.value).toString().slice(0, 4)
                                                        }}
                                                        InputProps={{
                                                            readOnly: formValues.checkBoxStatus,
                                                            endAdornment: <Avatar style={avatarStyle}><ReceiptIcon /></Avatar>
                                                        }} />
                                                </Box>
                                            </Grid>
                                        </Grid>
                                        <Grid container md={12} >
                                            <Grid md={6} sx={{ p: "1px", pr: 1 }}>
                                                <Box sx={{ marginRight: 5, marginBottom: 10 }}>
                                                    <TextField label='Name '
                                                        placeholder='Name/Company Name'
                                                        onChange={(e) => {
                                                            if (!new RegExp('^([A-Z ]+(?: [A-Z]+)?)$').test(e.target.value.toUpperCase())) {
                                                                setFormValues({
                                                                    ...formValues,
                                                                    'name': e.target.value.toUpperCase(),
                                                                    'nameShowError': true,
                                                                    'nameerrorMsg': 'Name: Special characters($,&,%...) & Numbers are not allowed'
                                                                })
                                                            } else {
                                                                setFormValues({ ...formValues, 'nameShowError': false, 'name': e.target.value.toUpperCase() })
                                                            }
                                                        }

                                                        }
                                                        fullWidth
                                                        variant={formValues.checkBoxStatus ? "filled" : "outlined"}
                                                        color="success"
                                                        focused
                                                        value={formValues.name}
                                                        required
                                                        InputProps={{
                                                            readOnly: formValues.checkBoxStatus,
                                                            style: { textTransform: 'capitalize' },
                                                            endAdornment: <Avatar style={avatarStyle}><AccountCircle sx={{ color: 'success' }} /></Avatar>
                                                        }} />
                                                </Box >
                                            </Grid>
                                            <Grid md={6} sx={{ p: "1px", pr: 1 }}>
                                                <Box sx={{ marginBottom: 10 }}>
                                                    <TextField label='Mobile No '
                                                        placeholder='Mobile Number'
                                                        variant={formValues.checkBoxStatus ? "filled" : "outlined"}
                                                        type='number'
                                                        fullWidth
                                                        onInput={(e) => {
                                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 10)
                                                        }}
                                                        value={formValues.mobileNo}
                                                        color="success" focused
                                                        required
                                                        onChange={(e) => {
                                                            if (e.target.value.length < 10) {
                                                                setFormValues({
                                                                    ...formValues,
                                                                    'mobileNo': e.target.value,
                                                                    'mobileShowError': true,
                                                                    'mobileerrorMsg': 'Please enter valid 10 digit Mobile No.'
                                                                })
                                                            } else {
                                                                setFormValues({ ...formValues, 'mobileShowError': false, 'mobileNo': e.target.value })
                                                            }
                                                        }

                                                        }
                                                        InputProps={{
                                                            readOnly: formValues.checkBoxStatus,
                                                            endAdornment: <Avatar style={avatarStyle}><PhoneIphoneOutlinedIcon /></Avatar>
                                                        }} />
                                                </Box>

                                            </Grid>
                                        </Grid>
                                        {formValues.invoiceError ? <Alert severity="error" sx={{ padding: 0, fontSize: 12 }}>{formValues.invoiceErrorMsg}</Alert> : null}

                                        {formValues.captchaError ? <Alert severity="error" sx={{ padding: 0, fontSize: 12 }}>{formValues.captchaErrorMsg}</Alert> : null}
                                        {formValues.nameShowError ? <Alert severity="error" sx={{ padding: 0, fontSize: 12 }}>{formValues.nameerrorMsg}</Alert> : null}
                                        {formValues.mobileShowError ? <Alert severity="error" sx={{ padding: 0, fontSize: 12 }}>{formValues.mobileerrorMsg}</Alert> : null}
                                        {formValues.invoiceShowError ? <Alert severity="error" sx={{ padding: 0, fontSize: 12 }}>{formValues.invoiceerrorMsg}</Alert> : null}

                                        {formValues.consentError ? <Alert severity="error" sx={{ padding: 0, fontSize: 12 }}>{formValues.consentErrorMsg}</Alert> : null}

                                        {!formValues.sendOTPClicked ? <div style={fieldStyle}>
                                            <Captcha validationCheck={validationCheck} />
                                        </div> : null}
                                        {!formValues.sendOTPClicked ? <div style={fieldStyle}>
                                            <FormControlLabel
                                                labelPlacement="end"
                                                control={
                                                    <Checkbox
                                                        name="checkedB"
                                                        color="success"
                                                        checked={formValues.checkBoxStatus}
                                                        disabled={formValues.mobileNo == '' || formValues.name == '' || formValues.lastFourDigitInvoice == '' || !formValues.captchaStatus || formValues.captchaError || formValues.nameShowError || formValues.mobileShowError || formValues.invoiceShowError}
                                                        onClick={(e) => onCheckBoxClicked(e)}
                                                    />
                                                }
                                                label={<label>By using this form you agree with the storage and handling of your data by this  site accordance with our<a target="_blank" href="https://www.tatasteel.com/privacy-policy/"> Privacy Policy</a></label>}
                                            />
                                        </div> : null}
                                        {formValues.showError ? <Alert severity="error" onClose={() => setFormValues({ ...formValues, 'showError': false })}>{formValues.errorMsg}</Alert> : null}
                                        {!formValues.sendOTPClicked ? <div style={fieldStyle}>
                                            <Button type='button' onClick={() => handleSendOTP('SENDOTP')} color='primary' variant="contained" style={btnstyle} disabled={formValues.name == '' || formValues.lastFourDigitInvoice == '' || formValues.mobileNo == '' || !formValues.captchaStatus || !formValues.checkBoxStatus || formValues.progress || formValues.show_pdf || formValues.nameShowError || formValues.mobileShowError || formValues.invoiceShowError || formValues.invoiceError || !formValues.consent} size="large">Send OTP </Button>
                                        </div> : null}
                                        {formValues.sendOTPClicked ? <div style={fieldStyle}>
                                            <TextField label='OTP '
                                                type='number'
                                                color="success"
                                                variant="outlined"
                                                value={formValues.otp}
                                                onInput={(e) => {
                                                    e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 5)
                                                }}
                                                required
                                                onChange={handleOtpChange}
                                            />
                                            <div style={fieldStyle}>
                                                Didn't received OTP ?  <Link
                                                    onClick={() => handleSendOTP('RESENDOTP')}
                                                >
                                                    Resend OTP
                                            </Link></div>
                                        </div> : null}
                                        {formValues.progress ? <LinearProgress color="success" /> : null}

                                        {formValues.sendOTPClicked ? <div style={fieldStyle}>
                                            <Button onClick={handleSubmit} type='button' color='primary' variant="contained" style={btnstyle} disabled={formValues.submit_disable} size="large">Submit </Button>

                                        </div> : null}
                                        {formValues.showSuccess ? <Alert severity="success" onClose={() => setFormValues({ ...formValues, 'showSuccess': false })}>Data Saved Successfully</Alert> : null}


                                        <Typography variant="caption" display="block" gutterBottom>
                                            <label style={{ color: "red" }}>
                                                Note: This TC is electronically generated, and portal is for genuine customers of TSL products.
                                                                Legal actions will be imposed on forging of the document.
                                    </label>


                                        </Typography>
                                        <Typography variant="caption" display="block" gutterBottom> © Copyright, 2022-{new Date().getFullYear()} TATA Steel Ltd.
                                    </Typography>
                                        <Typography variant="caption" display="block" gutterBottom> <span style={{ fontSize: 10, marginLeft: '80%', marginRight: 0 }}> V1.0.1 </span>
                                        </Typography>
                                    </Scrollbars>
                                </Paper>

                            </form>
                        </Grid></Grid>
                </MuiThemeProvider>
            </Grid> :  <Grid container className={classes.root} md={12} >
                    {/* <iframe src={`data:application/pdf;base64,${formValues.pdf}`} title="OnlineTcPdf" width='100%' height="100%"/> */}
                 
                    <Document
                        width='100%'
                         height='100%'
                         onLoadSuccess={({ numPages })=>setNumPages(numPages)}
                        file={`data:application/pdf;base64,${formValues.pdf}`}
                        >
                     {/* {formValues.pagesArray.map(page => (
            <Page pageNumber={page} />
        ))} */}
                {Array.apply(null, Array(numPages))
            .map((x, i)=>i+1)
            .map(page => <Page pageNumber={page}/>)}
                    </Document>
                    <a href={`data:application/pdf;base64,${formValues.pdf}`} download={`${formValues.E_INV_NO}`}>save</a>
{/* <Button>Save</Button> */}
  {/* <PDFDownloadLink document={   <Document
                        width='100%'
                         height='100%'
                        file={`data:application/pdf;base64,${formValues.pdf}`}
                        >
                     {[1,2].map(page => (
            <Page pageNumber={page} />
        ))}
                    </Document>} fileName="somename.pdf">
      {({ blob, url, loading, error }) => (loading ? 'Loading document...' : 'Download now!')}
    </PDFDownloadLink> */}




                </Grid>}
        </div>
    )
};
export default LandingPage;






